module.exports = __webpack_public_path__ + "img/carat.9a261e2.webp";